import React, { useState, useEffect } from "react";

import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getModuleState } from "../../redux/reducers/ModuleStateReducer";

import OverviewStatus from "./OverviewStatus";
import { EOverviewModuleStatus } from "./OverviewStatus";

import { Module } from "../../Model/Module";
import { EModuleType } from "../../Model/EModuleType";
import { EPsrState, EPsrPosition } from "../../Model/ModuleState";

const psrLocationTextMap: Record<EPsrPosition, string> = {
  [EPsrPosition.Unknown]: "Unknown",
  [EPsrPosition.FrontOfFixedCarriage]: "Fixed Carriage",
  [EPsrPosition.FrontOfImager]: "Imager",
  [EPsrPosition.FrontOfLoadPort]: "Load Port",
  [EPsrPosition.FrontOfMovableCarrier1]: "Movable Carrier 1",
  [EPsrPosition.FrontOfMovableCarrier2]: "Movable Carrier 2",
  [EPsrPosition.SafePosition]: "Safe Position",
};

type PsrStatusProps = {
  module: Module;
};

function getModuleStatus(psrStatus?: EPsrState) {
  switch (psrStatus) {
    case EPsrState.Available:
      return EOverviewModuleStatus.Idle;
    case EPsrState.Busy:
      return EOverviewModuleStatus.Busy;
    default:
      return EOverviewModuleStatus.Error;
  }
}

export default function PsrStatus(props: PsrStatusProps) {
  const { module } = props;
  const moduleState = useTypedSelector((state) =>
    getModuleState(state, module.identifier)
  );

  const psrState = moduleState?.psr;

  const [psrLocationText, setPsrLocationText] = useState(
    psrLocationTextMap[EPsrPosition.Unknown]
  );

  useEffect(() => {
    setPsrLocationText(
      psrState?.location != null
        ? psrLocationTextMap[psrState.location]
        : psrLocationTextMap[EPsrPosition.Unknown]
    );
  }, [psrState]);

  const statusses = {
    Status: psrState?.status,
    Location: psrLocationText,
  };
  const moduleStatus = getModuleStatus(psrState?.state);

  return (
    <OverviewStatus
      moduleType={EModuleType.PSR}
      name={"PSR"}
      statusses={statusses}
      moduleStatus={moduleStatus}
    />
  );
}
